export default "__VITE_ASSET__D42GHdEg__"